<template>
  <div class="custom-cookie">
    <vue-cookie-accept-decline
      :ref="'cookie'"
      :elementId="'cookie'"
      :debug="false"
      :position="'bottom-left'"
      :type="'floating'"
      :disableDecline="false"
      :transitionName="'slideFromBottom'"
      :showPostponeButton="false"
    >
      <div slot="message">
        <div class="cookie-box">
          <div
            class="
              flex-display
              js-between
              ai-center
              pd-x-1 pd-y-4
              color-bg-warning-strong-2
              change-display
            "
          >
            <div class="text-left box-inside-cookie">
              <p class="text-font-14 color-white">
                เราใช้คุกกี้เพื่อมอบประสบการณ์การใช้งานที่ดีที่สุดบนเว็บไซต์ของเรา
                รวมทั้งเพื่อ ปรับเนื้อหาและโฆษณาให้เหมาะกับบุคคล เพื่อมอบฟีเจอร์
              </p>
              <p class="text-font-14 color-white">
                โซเชียลมีเดียและเพื่อ วิเคราะห์ ปริมาณการใช้งาน
                คุกกี้เหล่านี้รวมถึงคุกกี้สื่อที่กำหนดเป้าหมายและคุกกี้
                <span
                  @click="dialogCookie = true"
                  class="text-underline cursor-pointer"
                  >ข้อมูลเพิ่มเติม</span
                >
              </p>
            </div>
            <div class="box-inside-cookie">
              <!-- <u class="text-font-14 pd-r-4 color-white">ตั้งค่าคุกกี้</u> -->
              <el-button @click="allowCookie" round class="primary"
                >อนุญาตทั้งหมด</el-button
              >
            </div>
          </div>
        </div>

        <el-dialog :visible.sync="dialogCookie" class="set-width-modal">
          <h2 class="color-black mg-t-less">การตั้งค่าคุกกี้</h2>
          <p class="text-justify color-black tab-text">
            คุกกี้ที่จำเป็นอย่างยิ่ง
            คุกกี้เหล่านี้จำเป็นสำหรับการทำงานของเว็บไซต์ของเราและไม่สามารถ
            ปิดในระบบของเราได้
            โดยปกติคุกกี้เหล่านี้จะถูกตั้งค่าเพื่อตอบสนองต่อสิ่งที่คุณกระทำเท่านั้น
            ซึ่งรวมถึง คำขอบริการ เช่น การตั้งค่าการกำหนดลักษณะความเป็นส่วนตัว
            การเข้าสู่ระบบ หรือการกรอกแบบ ฟอร์ม
            คุณสามารถตั้งค่าเบราว์เซอร์ให้บล็อกหรือแจ้งเตือนให้คุณทราบเกี่ยวกับคุกกี้เหล่านี้
            แต่หลังจาก นั้นบางส่วนของเว็บไซต์จะใช้งานไม่ได้
            คุกกี้เหล่านี้ไม่เก็บข้อมูลที่สามารถระบุตัวตนของคุณไว้
          </p>
          <div class="pd-t-2 flex-display ai-center js-between respon-flex">
            <!-- <span class="text-underline cursor-pointer color-primary"
              >ข้อมูลเพิ่มเติม</span
            > -->
            <div></div>
            <div class="flex-display ai-center respon-flex mt-20">
              <el-button @click="allowCookie" type="primary" round
                >อนุญาตทั้งหมด</el-button
              >
              <!-- <el-button @click="dialogCookie = false" type="primary" round
                >บันทึกการตั้งค่า</el-button
              > -->
            </div>
          </div>
        </el-dialog>
      </div>
    </vue-cookie-accept-decline>
  </div>
</template>

<script>
import VueCookieAcceptDecline from "vue-cookie-accept-decline";

export default {
  components: {
    "vue-cookie-accept-decline": VueCookieAcceptDecline,
  },
  data() {
    return {
      dialogCookie: false,
    };
  },
  mounted() {
    // this.$refs.cookie.removeCookie();
  },
  methods: {
    allowCookie() {
      this.$refs.cookie.accept();
    },
  },
};
</script>

<style scoped>
.cookie-box {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 999;
}
.tab-text {
  text-indent: 80px;
}
@media (max-width: 575.98px) {
  .respon-flex {
    display: block;
  }
  .mt-20 {
    margin-top: 20px;
  }
}
@media (max-width: 400px) {
  .mt-20 .el-button {
    display: block;
    width: 100%;
  }
  .el-button + .el-button {
    margin-left: 0;
    margin-top: 10px;
  }
}
</style>
